/*
 * Copyright (c) 2020 Signum+ Software & Facility GmbH
 * Author: jahn@signum-plus.at
 */

import { Component, ViewEncapsulation, ChangeDetectionStrategy, Input, HostBinding } from '@angular/core';
import { BackdropModel } from '@typescript-kit/view';
import { BaseDirective } from '../../directive/base.directive';
import { ChangedEvent } from '@typescript-kit/core';

@Component({
  selector: 'kit-backdrop',
  templateUrl: './backdrop.component.html',
  styleUrls: ['./backdrop.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class BackdropComponent extends BaseDirective<BackdropModel> {

  get hostClass(): string {
    return 'kit-backdrop';
  }

}
